import * as React from 'react'

export function SafeFragment(props: any) {
  return <>{props.children}</>
}
